export const IS_DEV = process.env.NODE_ENV === "development";
export const API_URL = process.env.NODE_ENV === "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;
